import React from 'react';

import { FormattedMessage } from 'react-intl';

import logo from '../../../Assets/Images/ednl-logo.png';
import elevatorPic from '../../../Assets/bwbuilding.jpg';

import classes from '../styles/Login.module.scss';
import { useQuery } from '@tanstack/react-query';
import { versionNumberQueryOptions } from 'Providers/VersionQueryOptions';
import { LiftStatusStorage } from 'Utils/Storage';
import { Navigate } from 'react-router-dom';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const { userToken } = LiftStatusStorage;

  if (userToken) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className={classes.login}>
      <div className={classes.leftDiv}>
        <img src={logo} alt="ednl logo" />
        <h2>
          <FormattedMessage id="liftstatus" />
        </h2>

        {children}

        <VersionNumber />
      </div>

      <div className={classes.rightDiv}>
        <img src={elevatorPic} alt="black and white building" />
      </div>
    </div>
  );
};

function VersionNumber() {
  const vesionNumberQuery = useQuery(versionNumberQueryOptions());

  return (
    <p className={classes.versionNumber}>{vesionNumberQuery.data?.version}</p>
  );
}

export default AuthLayout;
